"use client";

import { motion, useReducedMotion } from "@/lib/motion";
import { scrollRevealViewport } from "@/lib/motion-viewport";
import { Check, ArrowUpRight } from "@/components/icons";
import { SectionHeader } from "@/components/ui";
import { VERDICT_CARDS } from "./data";
import { DECODO_URL } from "./pricing-data";

const MotionDiv = motion.div;

export default function DecodoAlternativeVerdict() {
  const prefersReducedMotion = useReducedMotion();

  const fadeUp = (delay = 0) => ({
    initial: prefersReducedMotion ? {} : { opacity: 0, y: 24 },
    whileInView: prefersReducedMotion ? {} : { opacity: 1, y: 0 },
    viewport: scrollRevealViewport,
    transition: { duration: 0.55, delay },
  });

  return (
    <section
      className="full-bleed band-wash bg-band py-section border-border border-b"
      aria-labelledby="verdict-heading"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <MotionDiv {...fadeUp(0)} className="mb-14 max-w-2xl">
          <SectionHeader
            eyebrow="Quick Verdict"
            id="verdict-heading"
            heading="The honest answer depends on your workload."
            body="Neither provider is better at everything. Here is where each one genuinely wins."
          />
        </MotionDiv>

        <div className="grid gap-5 lg:grid-cols-2">
          {VERDICT_CARDS.map((card, i) => (
            <MotionDiv
              key={card.provider}
              {...fadeUp(i * 0.08)}
              className="bg-card card-wash card-hover border-border relative overflow-hidden rounded-2xl border p-7"
              style={
                card.provider === "proxidize"
                  ? {
                      borderColor: "color-mix(in srgb, var(--brand-green) 38%, transparent)",
                      boxShadow:
                        "0 18px 44px -28px color-mix(in srgb, var(--brand-green) 55%, transparent)",
                    }
                  : undefined
              }
            >
              <h3 className="text-foreground relative mb-5 text-lg font-semibold">{card.title}</h3>
              <ul className="relative space-y-3">
                {card.points.map((point) => (
                  <li
                    key={point}
                    className="text-muted-foreground flex items-start gap-2.5 text-sm leading-relaxed"
                  >
                    <Check
                      size={15}
                      className="mt-0.5 shrink-0"
                      style={{ color: "var(--brand-green)" }}
                      aria-hidden="true"
                    />
                    {point}
                  </li>
                ))}
              </ul>
              {card.provider === "decodo" && (
                <a
                  href={DECODO_URL}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="text-muted-foreground hover:text-foreground mt-6 inline-flex items-center gap-1.5 text-sm font-medium transition-colors"
                >
                  Visit Decodo
                  <ArrowUpRight size={14} aria-hidden="true" />
                </a>
              )}
            </MotionDiv>
          ))}
        </div>
      </div>
    </section>
  );
}
